// extracted by mini-css-extract-plugin
export default {"wrapper":"MiniLoader_wrapper__huU5S"};